import { makeStyles } from 'tss-react/mui';

export const RACHEL_PRODUCT_CARD_WIDTH = 152;
export const RACHEL_PRODUCT_CARD_ACTION_CLASS = 'rachel-product-card-action';

interface RachelProductCardStylesParams {
  isActionPinned: boolean;
}

export const useRachelProductCardStyles = makeStyles<RachelProductCardStylesParams>()(
  (theme, { isActionPinned }) => ({
    root: {
      position: 'relative',
      isolation: 'isolate',
      display: 'flex',
      flexDirection: 'column',
      flex: `0 0 ${RACHEL_PRODUCT_CARD_WIDTH}px`,
      width: RACHEL_PRODUCT_CARD_WIDTH,
      minWidth: 0,
      scrollSnapAlign: 'start',
      [`&:hover .${RACHEL_PRODUCT_CARD_ACTION_CLASS}, &:focus-within .${RACHEL_PRODUCT_CARD_ACTION_CLASS}`]:
        {
          display: 'flex',
        },
    },
    tagOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      display: 'flex',
      padding: theme.spacing(0.75),
      pointerEvents: 'none',
    },
    tag: {
      maxWidth: '100%',
      textTransform: 'lowercase',
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: theme.spacing(1.25, 0.5),
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    heading: {
      flex: 1,
      minWidth: 0,
    },
    action: {
      position: 'relative',
      zIndex: 1,
      display: isActionPinned ? 'flex' : 'none',
      flexShrink: 0,
      '@media (hover: none)': {
        display: 'flex',
      },
    },
    colors: {
      position: 'relative',
      zIndex: 1,
      alignSelf: 'flex-start',
    },
  }),
);
